import { useState } from 'react';
import { ContentCard } from '../../../components/ContentCard/ContentCard';
import { Button } from '../../../components/Form/Button';
import { Icon, close } from '../../../components/Icon/Icon';
import { Modal } from '../../../components/Modal/Modal';
import { useAddProductSearch } from '../../../hooks/useAddProductSearch';
import { useTranslation } from '../../../i18n/i18n';
import { ApiCartItem, ApiOrderItem } from '../../../types';
import './AddProductModal.css';
import { AddProductSearchForm } from './AddProductSearchForm';
import { ProductListing } from './ProductListing';

interface AddProductModalProps {
	onSave: (...args: any[]) => void;
	title?: string;
	deleting?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AddProductModal = ({ onSave, title, deleting }: AddProductModalProps): JSX.Element => {
	const [open, setOpen] = useState(false);
	const t = { ...useTranslation().editOrder, generic: useTranslation().generic };
	const { results, query, setQuery, loading, setPage, areMoreResults } = useAddProductSearch();
	const addProduct = (item: ApiOrderItem | ApiCartItem): void => onSave(item);
	const bodyClassName = ['modal-body', loading && 'loading'].join(' ');

	return (
		<>
			<Button disabled={deleting} style={{ marginBottom: '1.6rem' }} onClick={() => setOpen(true)}>
				{t.addProduct}
			</Button>

			<Modal
				className="add-product-modal"
				show={open}
				disableBodyScroll
				onDismiss={() => setOpen(false)}
				toggle={() => setOpen((prev) => !prev)}
			>
				<ContentCard className="add-product-content">
					<div className="modal-header">
						<div className="modal-header-title">{title}</div>
						<button className="close-btn" onClick={() => setOpen(false)}>
							<Icon shape={{ ...close, fill: 'black' }} size={20} />
						</button>
					</div>
					<div className={bodyClassName}>
						<AddProductSearchForm query={query} setQuery={setQuery} results={results} />
						<ProductListing onChange={addProduct} products={results?.items && query ? results.items : []} />
						<div className="search-footer">
							{!!query && areMoreResults && results?.items && (
								<Button
									className="big"
									disabled={loading}
									onClick={() => {
										setPage((prev) => prev + 1);
									}}
								>
									{loading ? t.generic.loading : t.generic.loadMore}
								</Button>
							)}
						</div>
					</div>
				</ContentCard>
			</Modal>
		</>
	);
};
